import React, { useState, useEffect, useCallback } from 'react';
import api from '../api';

// Single PIN screen — onAuth(access) returns 'management' or 'shopfloor'
export default function PinPadScreen({ onAuth }) {
  const [digits,   setDigits]   = useState([]);
  const [error,    setError]    = useState('');
  const [checking, setChecking] = useState(false);

  const verify = useCallback(async (pin) => {
    setChecking(true);
    try {
      const resp = await api.post('/auth/verify-pin', { pin });
      onAuth(resp.data.access);   // 'management' or 'shopfloor'
    } catch (err) {
      setError(err.response?.status === 401 ? 'Incorrect PIN — try again' : 'Connection error — please try again');
      setDigits([]);
    } finally {
      setChecking(false);
    }
  }, [onAuth]);

  useEffect(() => {
    if (digits.length === 4) verify(digits.join(''));
  }, [digits, verify]);

  const press = (d) => { setError(''); setDigits(p => p.length < 4 ? [...p, d] : p); };
  const back  = ()  => { setError(''); setDigits(p => p.slice(0, -1)); };

  const btn = {
    width: 76, height: 64, borderRadius: 10, border: '1px solid #30363d',
    background: '#1c2333', color: '#e6edf3', fontSize: 22,
    fontFamily: 'Rajdhani, sans-serif', fontWeight: 700,
    cursor: 'pointer', transition: 'background 0.1s',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  };
  const hover = (e, on) => { e.currentTarget.style.background = on ? '#243044' : '#1c2333'; };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: '#0d1117',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: 24, zIndex: 5000,
    }}>
      <div style={{ marginBottom: 32, textAlign: 'center' }}>
        <div style={{ fontFamily: 'Rajdhani, sans-serif', fontSize: 28, fontWeight: 700, color: '#f0a500', letterSpacing: 3 }}>
          CGS ERP
        </div>
        <div style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: 11, color: '#484f58', letterSpacing: 3, textTransform: 'uppercase', marginTop: 4 }}>
          Enter PIN to continue
        </div>
      </div>

      <div style={{ marginBottom: 8, display: 'flex', gap: 14 }}>
        {[0,1,2,3].map(i => (
          <div key={i} style={{
            width: 18, height: 18, borderRadius: '50%',
            background: i < digits.length ? '#f0a500' : 'transparent',
            border: `2px solid ${i < digits.length ? '#f0a500' : '#30363d'}`,
            transition: 'background 0.1s',
          }} />
        ))}
      </div>

      <div style={{ height: 24, marginBottom: 20, fontFamily: 'IBM Plex Mono, monospace', fontSize: 12, color: '#f85149', textAlign: 'center' }}>
        {checking ? 'Checking…' : error}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 76px)', gap: 10 }}>
        {[1,2,3,4,5,6,7,8,9].map(d => (
          <button key={d} style={btn} onClick={() => press(String(d))}
            onMouseOver={e => hover(e, true)} onMouseOut={e => hover(e, false)}>
            {d}
          </button>
        ))}
        <div />
        <button style={btn} onClick={() => press('0')}
          onMouseOver={e => hover(e, true)} onMouseOut={e => hover(e, false)}>0</button>
        <button style={{ ...btn, color: '#8b949e' }} onClick={back}
          onMouseOver={e => hover(e, true)} onMouseOut={e => hover(e, false)}>
          &#9003;
        </button>
      </div>
    </div>
  );
}
